import { useEffect, useState } from "react";
import { useLang } from "../../context/LanguageContext";

export default function CookieConsent() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_ok")) setShow(true);
  }, []);

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-white border border-[#E9E2D3] shadow-2xl rounded-2xl p-5 flex items-start gap-4"
    >
      <p className="text-sm text-gray-700 leading-relaxed">{t.cookie.text}</p>
      <button
        onClick={() => {
          localStorage.setItem("cookie_ok", "1");
          setShow(false);
        }}
        data-testid="cookie-accept"
        className="bg-[#1A2B4C] text-white text-xs uppercase tracking-widest px-4 py-2 rounded-full whitespace-nowrap"
      >
        {t.cookie.accept}
      </button>
    </div>
  );
}
